import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "chainSelect", "identifierInput", "form", "results" ]

  connect() {
    this.boundFrameLoadHandler = this.handleFrameLoad.bind(this)
    document.addEventListener(
      'turbo:frame-load',
      this.boundFrameLoadHandler
    );
  }

  disconnect() {
    document.removeEventListener(
      'turbo:frame-load',
      this.boundFrameLoadHandler
    );
  }

  handleFrameLoad(event) {
    if (event.target.id === 'tracked_tokens') {
      this.handleFormResponse()
    }
  }

  handleFormResponse() {
    this.enableForm()
  }

  validateAndSubmit() {
    const isValid = this.identifierInputTarget.checkValidity()

    if (isValid) {
      this.formTarget.requestSubmit()
      this.disableForm()
    }
  }

  clearResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.innerHTML = ''
    }
  }

  disableForm() {
    this.chainSelectTarget.disabled = true
    this.identifierInputTarget.disabled = true
  }

  enableForm() {
    this.chainSelectTarget.disabled = false
    this.identifierInputTarget.disabled = false
  }
}
